import {
  ImpCard,
  ImpContainer,
  ImpFlex,
  ImpText,
} from '@imprint-payments/imprint-ui';
import { TypographyName } from '@imprint-payments/imprint-ui/dist/DesignSystem/typography';

import { useImpState } from '../../app/hooks';
import Handpointing from '../../assets/icons/HandPointing.svg';
import styles from './CardWithDetails.module.css';

interface CardWithDetailsProps {
  width: string;
  last4: string;
  cvv: string;
  onCvvClick: () => void;
}

export default function CardWithDetails({
  width,
  last4,
  cvv,
  onCvvClick,
}: CardWithDetailsProps) {
  const { merchantData, language } = useImpState();
  const color = merchantData.color.contrastLight ?? '#fff';

  const getInfoSection = (
    label: string,
    digits: string,
    digitTypography: TypographyName
  ) => {
    return (
      <ImpFlex direction="column">
        <ImpContainer opacity={0.7}>
          <ImpText typography="body3" color={color}>
            {label.toUpperCase()}
          </ImpText>
        </ImpContainer>
        <ImpText typography={digitTypography} color={color}>
          <span className={styles.maskedDigits}>{digits}</span>
        </ImpText>
      </ImpFlex>
    );
  };

  return (
    <div className={styles.container} style={{ width }}>
      <div className={styles.cardBackContainer}>
        <ImpCard src={merchantData.cardBackImg} width={width} />
      </div>

      <div className={styles.cardInfoPanel}>
        <div className={styles.cardNumberSection}>
          {getInfoSection(
            language.cardNumber,
            //TODO: Design may change if we want to support AMEX (15 digits)
            `•••• ••••\n•••• ${last4}`,
            'headline1'
          )}
        </div>

        <div className={styles.cardSecuritySection}>
          <div className={styles.expSection}>
            {getInfoSection(language.EXP, '••/••', 'headline3')}
          </div>

          <div
            className={styles.cvvSection}
            role="button"
            aria-label="Copy CVV"
            tabIndex={0}
            onClick={onCvvClick}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onCvvClick();
              }
            }}
          >
            {getInfoSection(language.CVV, cvv, 'headline3')}
          </div>
        </div>
      </div>

      <img src={Handpointing} alt="Pointer" className={styles.pointerIcon} />
    </div>
  );
}
